export default function chunk(array, size) {
  if (!Number.isInteger(size) || size <= 0) {
    throw new TypeError(`chunk: size must be a positive integer, got ${size}`);
  }

  return Array.from(
    { length: Math.ceil(array.length / size) },
    (_v, i) => array.slice(i * size, i * size + size),
  );
}
